import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface ContentProps {
  children: ReactNode;
  className?: string;
}

export const Content = ({ children, className }: ContentProps) => (
  <div
    className={classNames("main__content mx-auto h-full max-w-5xl", className)}
  >
    {children}
  </div>
);
